import { createRouter, createWebHashHistory } from 'vue-router';  
import PreRegistration from '../components/HomePage.vue';
import SuccessPage from '../components/SuccessPage.vue'; // 引入新组件

const routes = [
  {
    path: '/',
    name: 'PreRegistration',
    component: PreRegistration,
  },
  {
    path: '/success',
    name: 'SuccessPage',
    component: SuccessPage,
  },
  // 可能还有其他路由配置
];

const router = createRouter({
  history: createWebHashHistory(process.env.BASE_URL), // 这里更改为使用哈希模式
  routes,
});

export default router;